import { render, staticRenderFns } from "./GenerateForm.vue?vue&type=template&id=310f9f9c"
import script from "./GenerateForm.vue?vue&type=script&lang=js"
export * from "./GenerateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('310f9f9c')) {
      api.createRecord('310f9f9c', component.options)
    } else {
      api.reload('310f9f9c', component.options)
    }
    module.hot.accept("./GenerateForm.vue?vue&type=template&id=310f9f9c", function () {
      api.rerender('310f9f9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/form/GenerateForm.vue"
export default component.exports